export default {
    "created": "Categoria a fost creata cu succes",
    "updated": "Categoria a fost actualizata cu succes",
    "deleted": "Categoria a fost ștersa cu succes",
    "restored": "Categoria a fost restaurata cu succes",
}
